import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import styles from "./physicianDetails.module.scss";
import {
  FaInstagram,
  FaLinkedin,
  FaFacebook,
  FaTwitter,
  FaYoutube,
  FaClinicMedical,
} from "react-icons/fa";
import { FcAbout } from "react-icons/fc";
import { GrSchedule } from "react-icons/gr";
import maleImg from "../../../images/CCImages/PhysicianImageMale.png";
import femaleImg from "../../../images/CCImages/PhysicianImageFemale.png";
import { useNavigate } from "react-router-dom";

import {
  getPhysicianById,
  associateClinic,
  resetAssociateClinicMessages,
  disassociateClinic,
  resetDisassociateClinicMessages,
  getPhysicianByClinicId,
  updatePhysicianSlotStatus,
  resetUpdatePhysicianSlotStatus,
} from "../../../store/slices/physicianSlice";
import { Link } from "react-router-dom";
import { Row, Col, Tab, Nav } from "react-bootstrap";
import AssociationClinic from "./physicianTab/associationClinic";
import About from "./physicianTab/about";
import Timeslot from "./physicianTab/timeslot";
import { getAllClinic } from "../../../store/slices/clinicSlice";
import {
  showToastifyError,
  showToastifySuccess,
} from "../../common/tostify/Toastifyresponse";

const PhysicianDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Monday");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const [formData, setFormData] = useState({
    id: "",
    physicianId: "",
    clinicId: "",
    clinicName: "",
    clinicUserId: "",
    regularFees: "",
    followupFees: "",
    emergencyFees: "",
    videConsultationFees: "",
    establishmentFees: "",
    clinicStatus: "Accepted",
    physicianStatus: "Accepted",
  });
  const [slotFormData, setSlotFormData] = useState({
    clinicId: "",
    clinicName: "",
    clinicUserId: "",
    physicianId: "",
    id: "",
    slot: "",
    fromTime: "",
    toTime: "",
    dayName: "Monday",
    sessionName: "Morning",
    slotDuration: null,
    waitingTime: null,
    consultationType: "",
  });
  const {
    physicianInfo,
    associateClinicSuccessMessage,
    associateClinicErrorMessage,
    disassociateClinicSuccessMessage,
    disassociateClinicErrorMessage,
    updatePhysicianSlotStatusSuccessMessage,
    updatePhysicianSlotStatusErrorMessage,
  } = useSelector((state) => state.physician);
  const { token } = useSelector((state) => state.auth);
  const physicianUserId = sessionStorage.getItem("physicianUserId");
  const associateModal = () => {
    setFormData({
      id: "",
      clinicId: "",
      clinicName: "",
      clinicUserId: "",
      physicianId: "",
      regularFees: "",
      followupFees: "",
      emergencyFees: "",
      videConsultationFees: "",
      establishmentFees: "",
      clinicStatus: "Accepted",
      physicianStatus: "Accepted",
    });
    setModalVisible(true);
  };
  const deleteModal = () => {
    setDeleteModalVisible(true);
  };

  useEffect(() => {
    dispatch(getAllClinic({ token }));
  }, [dispatch, token]);
  const { allClinicList, clinicInfo } = useSelector((state) => state.clinic);
  const { getPhysicianDetailsByClinic } = useSelector(
    (state) => state.physician
  );
const clinicId = clinicInfo?.[0]?.clinicId ||  null;
  useEffect(() => {
    dispatch(
      getPhysicianById({
        userId: physicianUserId,
        clinicId,
        token
      })
    );
  }, [clinicId, dispatch, selectedAction, physicianUserId, token]);

  useEffect(() => {
    if (associateClinicSuccessMessage) {
      showToastifySuccess(associateClinicSuccessMessage);
      dispatch(resetAssociateClinicMessages());
    }
    if (associateClinicErrorMessage) {
      showToastifyError(associateClinicErrorMessage);
      dispatch(resetAssociateClinicMessages());
    }

    if (disassociateClinicSuccessMessage) {
      showToastifySuccess(disassociateClinicSuccessMessage);
      dispatch(resetDisassociateClinicMessages());
    }
    if (disassociateClinicErrorMessage) {
      showToastifyError(disassociateClinicErrorMessage);
      dispatch(resetDisassociateClinicMessages());
    }
    if (updatePhysicianSlotStatusSuccessMessage) {
      showToastifySuccess(updatePhysicianSlotStatusSuccessMessage);
      dispatch(resetUpdatePhysicianSlotStatus());
    }
    if (updatePhysicianSlotStatusErrorMessage) {
      showToastifyError(updatePhysicianSlotStatusErrorMessage);
      dispatch(resetUpdatePhysicianSlotStatus());
    }
  }, [
    associateClinicSuccessMessage,
    associateClinicErrorMessage,
    disassociateClinicSuccessMessage,
    disassociateClinicErrorMessage,
    dispatch,
    updatePhysicianSlotStatusSuccessMessage,
    updatePhysicianSlotStatusErrorMessage,
  ]);
  const tabData = [
    { name: "About", icon: FcAbout, id: 1, component: About },
    { name: "Time Slot", icon: GrSchedule, id: 2, component: Timeslot },
    {
      name: "Associated Clinics",
      icon: FaClinicMedical,
      id: 3,
      component: AssociationClinic,
    },
  ];

  const handleSelectChange = (selectedOption, name) => {
    if (name === "clinic") {
      setFormData({
        ...formData,
        clinicId: selectedOption?.value,
        clinicName: selectedOption?.label,
        clinicUserId: selectedOption?.clinicUserId,
      });
    } else {
      const { name, value } = selectedOption.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSlotChange = (slot, slotName) => {
    const { name, value } = slot.target;
    setSlotFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAssociateClinic = async (e) => {
    e.preventDefault();
    await dispatch(
      associateClinic({
        id: formData?.id,
        clinicId: formData?.clinicId,
        clinicName: formData?.clinicName,
        clinicUserId: formData?.clinicUserId,
        physicianId: physicianInfo?.physicianId,
        regularFees: formData?.regularFees,
        followupFees: formData?.followupFees,
        emergencyFees: formData?.emergencyFees,
        videConsultationFees: formData?.videConsultationFees,
        establishmentFees: formData?.establishmentFees,
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
        token
      })
    );
    setModalVisible(false);
    setFormData({
      id: "",
      clinicId: "",
      clinicName: "",
      clinicUserId: "",
      physicianId: "",
      regularFees: "",
      followupFees: "",
      emergencyFees: "",
      videConsultationFees: "",
      establishmentFees: "",
      clinicStatus: "Accepted",
      physicianStatus: "Accepted",
    });
    setSelectedAction("");
    dispatch(
      getPhysicianById({
        userId: physicianUserId,
        clinicId,
        token
      })
    );
  };

  const editPhysicianFee = (item) => {
    setModalVisible(true);
    setSelectedAction("Update");
    setFormData({
      clinicId: item?.asociatedClinic[0]?.clinicId?._id,
      clinicUserId: item?.asociatedClinic[0]?.clinicId?.userId,
      physicianId: item?.physicianId,
      regularFees: item?.asociatedClinic[0]?.regularFees,
      followupFees: item?.asociatedClinic[0]?.followupFees,
      emergencyFees: item?.asociatedClinic[0]?.emergencyFees,
      videConsultationFees: item?.asociatedClinic[0]?.videConsultationFees,
      establishmentFees: item?.asociatedClinic[0]?.establishmentFees,
      clinicStatus: "Accepted",
      physicianStatus: "Accepted",
    });
  };

  const handleDisassociateClinic = (clinicId) => {
    setFormData({
      ...formData,
      clinicId: clinicId,
      physicianId: physicianInfo?.physicianId,
    });
    setDeleteModalVisible(true);
  };
  const handleDisassociateClinicConfirm = async (e) => {
    e.preventDefault();
    await dispatch(
      disassociateClinic({
        clinicId: formData?.clinicId,
        physicianId: formData?.physicianId,
        token
      })
    );
    setDeleteModalVisible(false);
    dispatch(
      getPhysicianById({
        userId: physicianUserId,
        clinicId,
        token
      })
    );
  };
  const handleTabChange = (tab, slotSession) => {
    setSlotFormData({
      ...slotFormData,
      dayName: tab,
    });
    setActiveTab(tab);
  };
  const handleAddButtonClick = (period) => {
    setSlotFormData({
      ...slotFormData,
      timeOfTheDay: period,
    });
    setSelectedPeriod(period);
    setModalIsOpen(true);
  };

  const handleSlotSave = async (e) => {
    e.preventDefault();
    await dispatch(
      associateClinic({
        id: slotFormData?.id,
        clinicId: slotFormData?.clinicId,
        clinicName: slotFormData?.clinicName,
        clinicUserId: slotFormData?.clinicUserId,
        physicianId: physicianInfo?.physicianId,
        slot: slotFormData?.slot,
        fromTime: slotFormData?.fromTime,
        toTime: slotFormData?.toTime,
        dayName: slotFormData?.dayName,
        sessionName: slotFormData?.sessionName,
        slotDuration: slotFormData?.slotDuration,
        waitingTime: slotFormData?.waitingTime,
        consultationType: slotFormData?.consultationType,
        token
      })
    );
    setModalIsOpen(false);
    setSlotFormData({
      clinicId: slotFormData?.clinicId,
      clinicName: slotFormData?.clinicName,
      clinicUserId: slotFormData?.clinicUserId,
      physicianId: "",
      id: "",
      slot: "",
      fromTime: "",
      toTime: "",
      dayName: slotFormData?.dayName || "Monday",
      sessionName: slotFormData?.sessionName || "Morning",
      slotDuration: null,
      waitingTime: null,
      consultationType: "",
    });
    dispatch(
      getPhysicianById({
        userId: physicianUserId,
        clinicId: slotFormData?.clinicId,
        token
      })
    );
    dispatch(
      getPhysicianByClinicId({
        userId: physicianUserId,
        clinicId: slotFormData?.clinicId,
        token
      })
    );
  };
  const handleClinicChange = useCallback((clinicId, clinicName, clinicUserId) => {
    setSlotFormData((prevData) => ({
      ...prevData,
      clinicId: clinicId,
      clinicName: clinicName,
      clinicUserId: clinicUserId,
    }));

    dispatch(
      getPhysicianByClinicId({
        userId: physicianUserId,
        clinicId,
        token
      })
    );
  }, [dispatch, physicianUserId, token]);

  const handleSlotStatus = async (item) => {
    try {
      await dispatch(updatePhysicianSlotStatus({ ...item, token }));
      dispatch(
        getPhysicianById({
          userId: physicianUserId,
          clinicId: slotFormData?.clinicId,
          token
        })
      );
      dispatch(
        getPhysicianByClinicId({
          userId: physicianUserId,
          clinicId: slotFormData?.clinicId,
          token
        })
      );
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
    <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="m-0">Pharma Invoice</h4>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/physician")}
        >
          Back to List
        </button>
      </div>
      <Row className={styles["profile-row"]}>
        <Col xl={6} className={styles["profile-col"]}>
          <div className={styles["profile-left-div"]}>
            <img  src={physicianInfo?.userId?.gender === "Male" ? maleImg : femaleImg} alt="" />
            <div className={styles["profile-left-info"]}>
              <h3>{physicianInfo?.name}</h3>
              <div className={styles["profile-logo"]}>
                <span>
                  <Link
                    to={physicianInfo?.instagram && physicianInfo?.instagram}
                  >
                    <FaInstagram />
                  </Link>
                </span>
                <span>
                  <Link to={physicianInfo?.facebook && physicianInfo?.facebook}>
                    <FaFacebook />
                  </Link>
                </span>
                <span>
                  <Link to={physicianInfo?.linkedIn && physicianInfo?.linkedIn}>
                    <FaLinkedin />
                  </Link>
                </span>
                <span>
                  <Link to={physicianInfo?.twitter && physicianInfo?.twitter}>
                    <FaTwitter />
                  </Link>
                </span>
                <span>
                  <Link to={physicianInfo?.youtube && physicianInfo?.youtube}>
                    <FaYoutube />
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </Col>
        <Col xl={6} className={styles["profile-col-right"]}>
          <ul className={styles["personal-info"]}>
            <li>
              <span className={styles["tittle"]}>Phone:</span>
              <span className={styles["text"]}>
                {physicianInfo?.phone ? physicianInfo?.phone : "N/A"}
              </span>
            </li>
            <li>
              <span className={styles["tittle"]}>Alt Mobile:</span>
              <span className={styles["text"]}>
                {physicianInfo?.alt ? physicianInfo?.alt : "N/A"}
              </span>
            </li>
            <li>
              <span className={styles["tittle"]}>Email:</span>
              <span className={styles["text"]}>
                {physicianInfo?.email ? physicianInfo?.email : "N/A"}
              </span>
            </li>
            <li>
              <span className={styles["tittle"]}>City:</span>
              <span className={styles["text"]}>
                {physicianInfo?.userId?.city?.name
                  ? physicianInfo?.userId?.city?.name
                  : "N/A"}
              </span>
            </li>
            <li>
              <span className={styles["tittle"]}>Education:</span>
              <span className={styles["text"]}>
                {physicianInfo?.education
                  ?.map((item) => item?.educationName)
                  .join(", ") || "N/A"}
              </span>
            </li>
            <li>
              <span className={styles["tittle"]}>Licence Id:</span>
              <span className={styles["text"]}>
                {physicianInfo?.license ? physicianInfo?.license : "N/A"}
              </span>
            </li>
          </ul>
        </Col>

        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="profile-tab">
                <div className="custom-tab-1">
                  <Tab.Container
                    defaultActiveKey={tabData[0]?.name?.toLowerCase()}
                  >
                    <Nav as="ul" className="nav nav-tabs">
                      {tabData?.map((data, i) => (
                        <Nav.Item as="li" key={i}>
                          <Nav.Link eventKey={data?.name?.toLowerCase()}>
                            <data.icon className="me-2 mb-1" />
                            {data?.name}
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                    <Tab.Content>
                      {tabData?.map((data, i) => (
                        <Tab.Pane eventKey={data?.name.toLowerCase()} key={i}>
                          {data?.component && (
                            <data.component
                              physicianInfo={physicianInfo}
                              handleAssociateClinic={handleAssociateClinic}
                              handleSelectChange={handleSelectChange}
                              setModalVisible={setModalVisible}
                              modalVisible={modalVisible}
                              setFormData={setFormData}
                              formData={formData}
                              allClinicList={allClinicList}
                              associateModal={associateModal}
                              deleteModal={deleteModal}
                              handleDisassociateClinic={
                                handleDisassociateClinic
                              }
                              activeTab={activeTab}
                              handleTabChange={handleTabChange}
                              handleAddButtonClick={handleAddButtonClick}
                              modalIsOpen={modalIsOpen}
                              setModalIsOpen={setModalIsOpen}
                              selectedPeriod={selectedPeriod}
                              slotFormData={slotFormData}
                              setSlotFormData={setSlotFormData}
                              handleSlotChange={handleSlotChange}
                              handleClinicChange={handleClinicChange}
                              handleSlotSave={handleSlotSave}
                              getPhysicianDetailsByClinic={
                                getPhysicianDetailsByClinic
                              }
                              editPhysicianFee={editPhysicianFee}
                              selectedAction={selectedAction}
                              setSelectedAction={setSelectedAction}
                              handleSlotStatus={handleSlotStatus}
                            />
                          )}
                        </Tab.Pane>
                      ))}
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <Modal
        centered
        show={deleteModalVisible}
        onHide={() => setDeleteModalVisible(false)}
        size="sm"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <p>Do you want to delete this Clinic?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setDeleteModalVisible(false)}
            className="p-2"
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDisassociateClinicConfirm}
            className="p-2"
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PhysicianDetails;
